import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bind from 'lodash-decorators/bind';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import ContentStore from 'stores/Content.store';
import Link from 'common/components/LocalizedLink/LocalizedLink';

import messages from './CollapsedMenu.intl';
import commonMessages from 'common/messages/Layout.intl';

import styles from './CollapsedMenu.module.scss';

import { ANCHOR, FOR_INVESTORS_SIDE_MENU } from 'common/consts/common';
import { LANG_EN, LANG_PL } from 'common/consts/language-code';

import LanguageService from 'services/Language.service';

import polishFlag from 'common/images/pl.png';
import englishFlag from 'common/images/uk.png';
import { isOnMobile } from 'utils/device-utils';

@withRouter
@injectIntl
class CollapsedMenu extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  componentDidMount() {
    window.addEventListener('mousedown', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  handleClickOutside = e => {
    if (this.refs.navRef.contains(e.target)) {
      return;
    }
    this.props.onClose();
  };

  @Bind()
  onItemClick() {
    this.props.onClose();
  }

  @Bind()
  setLang(lang) {
    LanguageService.setLang(lang);
    LanguageService.setLocalStorageItem(lang);
    LanguageService.changePathname(this, lang, true);
  }

  render() {
    const language = LanguageService.getLang();
    const { content } = ContentStore;
    const showSubmenu = path => path === window.location.pathname;
    const menuItems = [
      {
        title: this.props.intl.formatMessage(commonMessages.ourCompanies),
        hash: ANCHOR.COMPANIES[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.missionAndVision),
        hash: ANCHOR.MISSIONANDVISION[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.strategy),
        hash: ANCHOR.STRATEGY[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.synergy),
        hash: ANCHOR.SYNERGY[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.history),
        hash: ANCHOR.HISTORY[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.authorities),
        hash: ANCHOR.AUTHORITIES[language]
      },
      {
        title: this.props.intl.formatMessage(
          commonMessages.corporateGovernance
        ),
        hash: ANCHOR.CORPORATEGOVERNANCE[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.teamOfExperts),
        hash: ANCHOR.TEAMOFEXPERTS[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.caseStudies),
        hash: ANCHOR.CASESTUDIES[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.jobOffers),
        hash: ANCHOR.JOBOFFERS[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.CSR),
        hash: ANCHOR.CSR[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.pressRoom),
        hash: ANCHOR.PRESSROOM[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.mediaAboutUs),
        hash: ANCHOR.MEDIAABOUTUS[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.news),
        hash: ANCHOR.NEWS[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.rodoPolicy),
        hash: ANCHOR.RODO_POLICY[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.zszPolicy),
        hash: ANCHOR.ZSZ_POLICY[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.contact),
        hash: ANCHOR.CONTACT[language]
      },
      {
        title: this.props.intl.formatMessage(commonMessages.forInvestors),
        hash: ANCHOR.FOR_INVESTORS[language],
        dontShow: (content && content.ForInvestorsHiddenNav) || !isOnMobile(),
        submenu:
          showSubmenu(ANCHOR.FOR_INVESTORS[language]) && FOR_INVESTORS_SIDE_MENU
      }
    ].filter(({ dontShow }) => !dontShow);
    const menuLanguages = [
      {
        img: englishFlag,
        title: this.props.intl.formatMessage(messages.langEN),
        lang: LANG_EN
      },
      {
        img: polishFlag,
        title: this.props.intl.formatMessage(messages.langPL),
        lang: LANG_PL
      }
    ];

    const SubmenuItems = props => {
      if (props.href) {
        return (
          <li>
            <a
              href={props.href}
              className={styles.SubNavLink}
              onClick={this.onItemClick}
            >
              {props.title[language]}
            </a>
          </li>
        );
      }
      return (
        <li>
          <Link
            to={props.hash}
            className={styles.SubNavLink}
            onClick={this.onItemClick}
          >
            {props.title[language]}
          </Link>
        </li>
      );
    };

    const ItemList = props => {
      return (
        <li>
          <Link
            to={props.hash}
            className={styles.NavLink}
            onClick={this.onItemClick}
          >
            {props.title}
          </Link>
          {props.submenu && (
            <ul className={styles.SubmenuList}>
              {props.submenu
                .filter(({ duplicate }) => !duplicate)
                .map((item, key) => <SubmenuItems key={key} {...item} />)}
            </ul>
          )}
        </li>
      );
    };

    const LangsList = props => {
      const { img, title, lang } = props;

      return (
        <li
          className={`
            ${styles.NavLang}
            ${LanguageService.isActive(lang) ? styles.Active : ''}
        `}
          onClick={() => this.setLang(lang)}
        >
          <span>
            <img className={styles.LanguageFlag} src={img} alt={title} />
            {title}
          </span>
        </li>
      );
    };

    const MenuItems = props => {
      const { items } = props;
      const itemList = items.map((item, key) => (
        <ItemList key={key} {...item} />
      ));
      return <ul className={styles.NavList}>{itemList}</ul>;
    };

    const MenuLangs = props => {
      const { langs } = props;
      const langsList = langs.map((lang, key) => (
        <LangsList key={key} {...lang} />
      ));
      return <ul className={styles.NavLangsList}>{langsList}</ul>;
    };

    return (
      <div ref="navRef" className={styles.NavListOpen}>
        <div className={styles.NavOpenRelativeBox}>
          <div className={styles.NavOpenAction} onClick={this.props.onClose}>
            <span className={styles.NavCloseText}>
              <strong>{this.props.intl.formatMessage(messages.button)}</strong>
            </span>
            <div className={styles.NavCloseIcon} />
          </div>
          <MenuItems items={menuItems} />
          <hr className={styles.NavHorizontalRule} />
          <MenuLangs langs={menuLanguages} />
          <div className={styles.MenuBackground} />
        </div>
      </div>
    );
  }
}

export default CollapsedMenu;



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Header/components/CollapsedMenu/CollapsedMenu.js